export default {"src":"/_next/static/media/butternutsquash.9cce669d.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};